import { render } from "./ListFaqPage.vue?vue&type=template&id=3227489a&scoped=true"
import script from "./ListFaqPage.vue?vue&type=script&lang=js"
export * from "./ListFaqPage.vue?vue&type=script&lang=js"

import "./ListFaqPage.vue?vue&type=style&index=0&id=3227489a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3227489a"]])

export default __exports__